import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadata, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { Currency } from '@currency/models/currency.model';
import { cash_types } from '@common/constants/cash-types';

export class AdminPaymentTableFilterFieldProvider implements FilterFieldProvider {

  readonly fieldMetaDataCollection: FieldMetadataCollection;

    constructor(private readonly currencies: Currency[]) {

    this.fieldMetaDataCollection = new FieldMetadataCollection();
    this.initialiseFields();
  }

    private initialiseFields() {

    const addFieldToFilterFieldMetadata = (fieldLabel: string, fieldName: string, items: any[]) => {
      const filterField = {
        name: fieldLabel,
        type: 'category',
        operators: FilterOperators.CategoryDefaults,
        options: items
      };
      this.fieldMetaDataCollection.set(filterField.name, new FieldMetadata(fieldName, filterField));
    };

    const paidDate = {
        name: 'Paid Date',
        type: 'date',
        operators: FilterOperators.AdminDateDefaults
      };
    this.fieldMetaDataCollection.set(paidDate.name, new FieldMetadata('SystemPaidDate', paidDate));

    addFieldToFilterFieldMetadata('Type', 'SystemType', this.getQueryBuilderCategories(cash_types));

    const reference = {
        name: 'Reference',
        type: 'string',
        operators: FilterOperators.AdminStringDefaults
    };
    this.fieldMetaDataCollection.set(reference.name, new FieldMetadata('SystemReference', reference));

    const amount = {
        name: 'Amount',
        type: 'number',
        operators: FilterOperators.AdminScalar
    };
    this.fieldMetaDataCollection.set(amount.name, new FieldMetadata('SystemAmount', amount));

    addFieldToFilterFieldMetadata('Currency', 'SystemCurrency', this.getQueryBuilderCategories(this.currencies.map((x:Currency)=>x.Code)));
  }

  private getQueryBuilderCategories(array: Array<string>) {
    let result = [];
    array.forEach((item) => {
      result.push({
        label: item,
        name: item,
        value: item
      });
    });

    return result;
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
